import React, { Component, Fragment } from 'react';
import Table from '@/components/EditableTable';
import { numberCheck } from '../../../../../services/helper/dataProcess';
import { OPEN_DRAIN, percentIndex, percentOutIndex, PUSH_PULL, getClockHz, getVoltageDisplay, getTimeDisplay, getGPIOSpecOptions, getSpecCheck } from '../../../../../services/Sierra/helper/measurementHelper';
import { SettingOutlined, ExclamationCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Popover, Radio, Tooltip } from 'antd';
import { getGPIOSpecLibrary } from '../../../../../services/Sierra/library';
import sierraLibrary from '../../../../../services/Sierra/library/libraryStorage';
import { GPIO_SPEC } from '../../../../../constants/libraryConstants';
import { getSimConfig } from '../../../../../services/Sierra/multiInterfaceSetup';
import { I2C } from '../../../../../services/PCBHelper/constants';
import '../new.css';
import "./index.css";

const columns = [{
  title: 'Model',
  dataIndex: 'model',
  key: 'model',
  width: '12.5%',
  render: (text) => {
    return <span
      className="measurement-table-component-title"
      title={text}
    >{text}</span>
  }
}, {
  title: 'Pin',
  dataIndex: 'pin',
  key: 'pin',
  width: '12.5%'
}, {
  title: 'VDD',
  dataIndex: 'vdd',
  key: 'vdd',
  width: '7%'
},
{
  title: 'VIH',
  dataIndex: 'vinh',
  key: 'vinh',
  width: '13%'
}, {
  title: 'VIL',
  dataIndex: 'vinl',
  key: 'vinl',
  width: '13%'
},
{
  title: 'VOH',
  dataIndex: 'vouth',
  key: 'vouth',
  width: '13%'
}, {
  title: 'VOL',
  dataIndex: 'voutl',
  key: 'voutl',
  width: '13%'
}];

const WarningIcon = (info) => {
  return <Tooltip title={info} placement='top'>
    <ExclamationCircleOutlined />
  </Tooltip>
};

const interfaceColumns = [{
  title: 'Model',
  dataIndex: 'model',
  key: 'model',
  width: '12%',
  render: (text) => {
    return <span
      className="measurement-table-component-title"
      title={text}
    >{text}</span>
  }
}, {
  title: 'Pin',
  dataIndex: 'pin',
  key: 'pin',
  width: '12%'
}, {
  title: 'VDD',
  dataIndex: 'vdd',
  key: 'vdd',
  width: '8%'
},
{
  title: 'VIH / VOH',
  dataIndex: 'vinh',
  key: 'vinh',
  width: '12%'
}, {
  title: 'VIL / VOL',
  dataIndex: 'vinl',
  key: 'vinl',
  width: '12%'
},
{
  title: 'Spec',
  dataIndex: 'specName',
  key: 'specName',
  width: '13%'
}, {
  title: 'V-High',
  dataIndex: 'vHigh',
  key: 'vHigh',
  width: '8%'
}, {
  title: 'V-Low',
  dataIndex: 'vLow',
  key: 'vLow',
  width: '8%'
}, {
  title: 'Rising Time',
  dataIndex: 'rising',
  key: 'rising',
  width: '8%'
}, {
  title: 'Falling Time',
  dataIndex: 'falling',
  key: 'falling',
  width: '8%'
},
/* {
  title: 'Setup Time',
  dataIndex: 'setup',
  key: 'setup',
  width: '8%'
},
{
  title: 'Hold Time',
  dataIndex: 'hold',
  key: 'hold',
  width: '8%'
} */];

const columnsIndex = ['v_high', 'v_low'];
const RadioGroup = Radio.Group

class MeasurementTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      columns: [],
      gpioSpecList: sierraLibrary.getTree(GPIO_SPEC) || []
    }
  }

  async componentDidMount() {
    const { tableType, isSweep, baseVerificationId, currentConfig } = this.props;
    if (tableType === "interface") {
      if (isSweep) {
        const data = await getSimConfig(baseVerificationId);
        this.clock = data && data.config ? (data.config.clock || "") : "";
      } else {
        this.clock = currentConfig && currentConfig.clock ? currentConfig.clock.value + currentConfig.clock.unit : "";
      }

      this.setState({
        gpioSpecList: sierraLibrary.getTree(GPIO_SPEC) || [],
      })
      this.initInterfaceColumns();
    } else {
      this.initColumns();
    }
  }

  componentDidUpdate = (prevProps) => {
    const { libraryTreeInfo, interfaceTag } = this.props;
    if (libraryTreeInfo && libraryTreeInfo.includes(GPIO_SPEC)) {
      this.setState({
        gpioSpecList: sierraLibrary.getTree(GPIO_SPEC) || []
      })
      this.props._updateLibraryTree && this.props._updateLibraryTree(null);
    }

    if (prevProps.interfaceTag !== interfaceTag) {
      this.initInterfaceColumns()
    }
  }

  initColumns = () => {
    let _columns = JSON.parse(JSON.stringify(columns))
    _columns.forEach(column => {

      if (column.dataIndex === "pin") {
        column.render = (text, record) => {
          let _text = "";
          const { type } = this.props;
          if (type === "result") {
            const list = text.split('::');
            if (list.length === 2) {
              const [comp, pin] = list;
              _text = `${comp} - ${pin}`;
            }
            if (list.length === 3) {
              const [pcb, comp, pin] = list;
              _text = `${comp} - ${pin} - ${pcb}`;
            }
          } else {
            const { Interfaces, isMultiPCB, isSweep } = this.props;
            _text = ((isSweep && isMultiPCB) || (Interfaces && Interfaces.length > 1)) && record.pcb ? `${record.comp} - ${record.pinNumber} - ${record.pcb}` : `${record.comp} - ${record.pinNumber}`;
          }

          return <span
            className="measurement-table-component-title"
            title={_text}
          >{_text}</span>
        }
      }

      if (column.dataIndex === "vdd") {
        column.title = () => {
          return (
            <div className="measurement-vdd-content">
              <span>VDD</span>
              <Popover
                content={this.vddDefinition()}
                title=""
                trigger="click"
              >
                <SettingOutlined title="Switch VDD Definition" className="measurement-vdd-setting-icon" />
              </Popover>
            </div>
          );
        }
      }

      if (columnsIndex.includes(column.dataIndex)) {
        const { isBase } = this.props;
        column.onCell = (record) => {
          return {
            record,
            edit: isBase ? false : true,
            dataIndex: column.dataIndex,
            allowEmpty: true,
            handleSave: (record) => this.editVoltage(record, column.dataIndex)
          }
        }
      } else if ([...percentIndex, ...percentOutIndex].includes(column.dataIndex)) {
        column.onCell = (record) => {
          const { isBase } = this.props;
          if (isBase) {
            return {
              edit: false
            }
          }
          let _dataIndex = column.dataIndex;
          if (percentOutIndex.includes(column.dataIndex) && record.usage === "Driver") {
            _dataIndex = column.dataIndex.replace("out", "in")
          } else if (record.usage === "Driver"
            || (percentOutIndex.includes(column.dataIndex) && record.usage !== "Driver")) {
            return { edit: false };
          }
          const unit = record[`${_dataIndex}_per`] ? "%" : "V";
          return {
            record,
            edit: 'input-with-select',
            dataIndex: record[`${_dataIndex}_per`] ? `${_dataIndex}_per` : _dataIndex,
            handleSave: (record) => this.savePercentValue(record, _dataIndex),
            allowEmpty: true,
            unit,
            unitList: [{ key: "V", title: 'V' }, { key: "%", title: '% VDD' }]
          }
        }

        column.render = (text, record) => {
          let _dataIndex = column.dataIndex;
          if (percentOutIndex.includes(column.dataIndex) && record.usage === "Driver") {
            _dataIndex = column.dataIndex.replace("out", "in")
          } else if (record.usage === "Driver" ||
            (percentOutIndex.includes(column.dataIndex) && record.usage !== "Driver")) {
            return null;
          }
          if (record[`${_dataIndex}_per`]) {
            return `${record[`${_dataIndex}_per`]}% (${record[_dataIndex]})`;
          }
          return record[_dataIndex];
        }
      }
    })
    this.setState({ columns: _columns });
  }

  initInterfaceColumns = () => {
    const { interfaceTag } = this.props;
    let _interfaceColumns = JSON.parse(JSON.stringify(interfaceColumns));
    if (interfaceTag === I2C) {
      _interfaceColumns.push({
        title: 'Setup Time',
        dataIndex: 'setup',
        key: 'setup',
        width: '8%'
      }, {
        title: 'Hold Time',
        dataIndex: 'hold',
        key: 'hold',
        width: '8%'
      }, {
        title: 'Valid Time',
        dataIndex: 'valid',
        key: 'valid',
        width: '8%'
      })
    } else if (interfaceTag !== I2C && _interfaceColumns.find(item => ["setup", "hold", "valid"].includes(item.key)) /* _interfaceColumns[_interfaceColumns.length - 1].key === "valid" */) {
      /*  _interfaceColumns.splice(_interfaceColumns.length - 1, 1); */
      _interfaceColumns = _interfaceColumns.filter(item => !["setup", "hold", "valid"].includes(item.key))
    }
    _interfaceColumns.forEach(column => {
      if (column.dataIndex === "pin") {
        column.render = (text, record) => {
          let _text = "";
          const { type } = this.props;
          if (type === "result") {
            const list = text.split('::');
            if (list.length === 2) {
              const [comp, pin] = list;
              _text = `${comp} - ${pin}`;
            }
            if (list.length === 3) {
              const [pcb, comp, pin] = list;
              _text = `${comp} - ${pin} - ${pcb}`;
            }
          } else {
            const { Interfaces, isMultiPCB, isSweep } = this.props;
            _text = ((isSweep && isMultiPCB) || (Interfaces && Interfaces.length > 1)) && record.pcb ? `${record.comp} - ${record.pinNumber} - ${record.pcb}` : `${record.comp} - ${record.pinNumber}`;
          }

          return <span
            className="measurement-table-component-title"
            title={_text}
          >{_text}</span>
        }
      }

      if (column.dataIndex === "vdd") {
        column.title = () => {
          return (
            <div className="measurement-vdd-content">
              <span>VDD</span>
              <Popover
                content={this.vddDefinition()}
                title=""
                trigger="click"
              >
                <SettingOutlined title="Switch VDD Definition" className="measurement-vdd-setting-icon" />
              </Popover>
            </div>
          );
        }
      }

      if (percentIndex.includes(column.dataIndex)) {
        column.onCell = (record) => {
          const { isBase } = this.props;
          if (isBase) {
            return {
              edit: false
            }
          }
          const unit = record[`${column.dataIndex}_per`] ? "%" : "V";
          return {
            record,
            edit: 'input-with-select',
            dataIndex: record[`${column.dataIndex}_per`] ? `${column.dataIndex}_per` : column.dataIndex,
            handleSave: (record) => this.savePercentValue(record, column.dataIndex),
            allowEmpty: true,
            unit,
            unitList: [{ key: "V", title: 'V' }, { key: "%", title: '% VDD' }]
          }
        }

        column.render = (_, record) => {
          if (record[`${column.dataIndex}_per`]) {
            return `${record[`${column.dataIndex}_per`]}% (${record[column.dataIndex]})`;
          }
          return record[column.dataIndex];
        }
      }

      if (column.dataIndex === 'specName') {
        column.onCell = (record) => {
          const { gpioSpecList } = this.state;
          const options = getGPIOSpecOptions(gpioSpecList, this.props.interfaceTag);
          return {
            record,
            edit: 'select',
            dataIndex: "specName",
            optGroup: true,
            notIncludesGroup: true,
            handleSave: (record) => this.selectSpec(record),
            handleClear: (record) => this.clearSpec(record),
            allowClear: true,
            allowEmpty: true,
            rowSpan: record.rowSpan ? record.rowSpan : 0,
            options,
            getPopupContainer: document.getElementById('root')
          }
        }
        column.render = (_, record) => {
          const { gpioSpecList } = this.state;
          const { tableData, interfaceTag, clockGroup } = this.props;
          const exist = !record.specId || gpioSpecList.find(it => it.id === record.specId);
          const warningMsg = getSpecCheck({ record, tableData, interfaceTag, clockGroup, clock: this.clock })

          return exist
            ? <Fragment><span className='measurement-setup-spec-title'>{record.specName}</span>
              <span className='measurement-setup-spec-title-warning-icon'>{warningMsg ? WarningIcon(warningMsg) : null}</span></Fragment>
            : <span>
              {record.specName}
              <Tooltip
                title={`${record.specName} has been deleted, the file is invalid.`}
                classNames={{ root: "aurora-tooltip" }}
              >
                <QuestionCircleOutlined className='aurora-file-check-icon' />
              </Tooltip>
            </span>
        }
      }

      if (["vHigh", "vLow"].includes(column.dataIndex)) {
        column.render = (_, record) => {
          const value = record.spec[column.dataIndex] || [];
          return record.spec && record.spec.id && value.length ? <span>[{getVoltageDisplay(value[0])}, {getVoltageDisplay(value[1])}]</span> : null
        }
      }

      if (["rising", "falling", "setup", "hold", "valid"].includes(column.dataIndex)) {
        column.render = (_, record) => {
          const value = record.spec[column.dataIndex] || [];
          return record.spec && record.spec.id && value.length ? <span>[{getTimeDisplay(value[0])}, {getTimeDisplay(value[1])}]</span> : []
        }
      }
    })
    this.setState({ columns: _interfaceColumns })
  }

  vddDefinition = () => {
    const { modelType, isBase } = this.props;
    return <div className="measure-vdd-radio-content">
      <RadioGroup
        onChange={this.props.updateModelType}
        className="measure-vdd-radio-group"
        value={modelType}
        disabled={isBase || false}
      >
        <Radio value={OPEN_DRAIN}>{OPEN_DRAIN}</Radio>
        <Radio value={PUSH_PULL}>{PUSH_PULL}</Radio>
      </RadioGroup>
    </div>
  }

  editVoltage = (record, dataIndex) => {
    const { tableData } = this.props;
    let _tableData = [...tableData];

    const index = tableData.findIndex(t => t.pin === record.pin);
    if (index > -1) {
      const value = record[dataIndex];
      if (parseFloat(value) === parseFloat(_tableData[index][dataIndex])) {
        return;
      }
      const error = numberCheck(value);
      if (!error) {
        _tableData[index][dataIndex] = Number(value);
        this.props.updateTableData(_tableData, true);
      }
    }
  }

  savePercentValue = (record, dataIndex) => {
    const { value, unit } = record;
    const { tableData } = this.props;
    let _tableData = [...tableData];

    const index = tableData.findIndex(t => t.pin === record.pin);
    if (index > -1) {
      if ((unit === "%" && parseFloat(value) === parseFloat(_tableData[index][`${dataIndex}_per`]))
        || (unit === "V" && parseFloat(value) === parseFloat(_tableData[index][dataIndex]))) {
        return;
      }
      const error = numberCheck(value);
      if (!error) {
        if (unit === '%') {
          const vdd = _tableData[index]['vdd'];
          _tableData[index][dataIndex] = Number((Number(value) / 100 * vdd).toFixed(4));
          _tableData[index][`${dataIndex}_per`] = Number(value)
        } else {
          _tableData[index][dataIndex] = Number(value);
          _tableData[index][`${dataIndex}_per`] = null;
          delete _tableData[index][`${dataIndex}_per`]
        }
        this.props.updateTableData(_tableData, true);
      }
    }
  }

  selectSpec = async (record) => {
    const { specName } = record;
    const gpioSpecList = sierraLibrary.getTree(GPIO_SPEC);
    const specId = gpioSpecList.find(it => it.name === specName).id;
    let specInfo = null;
    try {
      specInfo = await getGPIOSpecLibrary(specId);
    } catch (error) {
      console.error(error)
      return;
    }
    if (!specInfo || !specInfo.config) {
      return;
    }

    const { tableData, clockGroup } = this.props;
    const { vdds, clocks } = specInfo.config;

    const _tableData = tableData.map(t => {
      const { vdd } = t;
      const vddConfig = vdds.find(it => it.vdd === String(vdd));
      const { vHigh = {}, vLow = {} } = vddConfig || {};

      const signalClock = clockGroup ? clockGroup[t.signal] || this.clock : this.clock;
      const clockConfig = clocks.find(it => getClockHz(it.clock) === getClockHz(signalClock));
      const { rising = {}, falling = {}, setup = {}, hold = {}, valid = {} } = clockConfig || {};

      return {
        ...t,
        specId,
        specName,
        spec: {
          id: specInfo.id,
          name: specInfo.name,
          vHigh: vddConfig ? [vHigh.min || "", vHigh.max || ""] : [],
          vLow: vddConfig ? [vLow.min || "", vLow.max || ""] : [],
          rising: clockConfig ? [rising.min || "", rising.max || ""] : [],
          falling: clockConfig ? [falling.min || "", falling.max || ""] : [],
          setup: clockConfig ? [setup.min || "", setup.max || ""] : [],
          hold: clockConfig ? [hold.min || "", hold.max || ""] : [],
          valid: clockConfig ? [valid.min || "", valid.max || ""] : [],
        }
      }
    });
    this.props.updateTableData(_tableData);
  }

  clearSpec = () => {
    const { tableData } = this.props;

    const _tableData = tableData.map(t => {
      return {
        ...t,
        specId: "",
        specName: "",
        spec: {
          id: "",
          name: "",
          vHigh: [],
          vLow: [],
          rising: [],
          falling: []
        }
      }
    });
    this.props.updateTableData(_tableData);
  }

  render() {
    const { columns } = this.state;
    const { tableData } = this.props;
    return <Fragment>
      <Table
        columns={columns}
        rowKey={(record) => record.pin}
        dataSource={JSON.parse(JSON.stringify(tableData || []))}
        bordered
        size="small"
        tableLayout="fixed"
        className="post-process-panel-data-table"
      />
    </Fragment>
  }

}

export default MeasurementTable;